import { render, staticRenderFns } from "./fccLocalDeProvaStatus.vue?vue&type=template&id=a2ef0df2"
import script from "./fccLocalDeProvaStatus.vue?vue&type=script&lang=js"
export * from "./fccLocalDeProvaStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports